import { StyleSheet } from 'react-native';
import type { StylesMap } from 'types';
import Theme from 'Theme';

const styles: StylesMap = {
    selectButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        height: '100%',
        width: '100%',
        padding: 4,
        borderWidth: 1,
        borderColor: Theme.secondaryButtonBorderColor,
        borderRadius: 4
    },
    selectButtonLabel: {
        color: `${Theme.primaryTextColor}CC`,
        marginBottom: 1
    },
    selectButtonIcon: {
        marginBottom: 2
    }
};

export default StyleSheet.create(styles);
